module.exports = "/packs/icon-progress-done-6fb84165e8ae41940f660234f6310acd.png";